import { render, staticRenderFns } from "./ova.vue?vue&type=template&id=1af8f2ea&scoped=true&"
import script from "./ova.vue?vue&type=script&lang=js&"
export * from "./ova.vue?vue&type=script&lang=js&"
import style0 from "./ova.vue?vue&type=style&index=0&id=1af8f2ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af8f2ea",
  null
  
)

export default component.exports